import React, {Component} from "react";
import Route from "react-router-dom/Route";
import * as Markdown from "react-markdown";
import {Switch} from "react-router-dom";

class Content extends Component {

    render() {
        const contents = [];
        const errorpage = [];
        for (var i = 0; i < this.props.pages.length; i++) {
            const content = this.props.pages[i].fields.contentPage;
            const pdf = this.props.pages[i].fields.pdf;
            if (this.props.pages[i].fields.default) {
                errorpage.push(<Route key={i} render={
                    () => {
                        return (
                            <div className="c-content-box">
                                <Markdown source={content}/>
                            </div>
                        )
                    }
                }/>);
            }
            if (pdf) {
                contents.push(<Route key={i} path={this.props.pages[i].fields.path} exact render={
                    () => {
                        return (
                            <div className="c-content-box">
                                <Markdown source={content}/>
                                <iframe src={pdf} sandbox width="100%" height="800px"></iframe>
                            </div>
                        )
                    }
                }/>);
            } else {
                contents.push(<Route key={i} path={this.props.pages[i].fields.path} exact render={
                    () => {
                        return (
                            <div className="c-content-box">
                                <Markdown source={content}/>
                            </div>
                        )
                    }
                }/>);
            }
        }
        return (
            <div id="page-content">
                <div className="page-content-inner">
                    <div className="c-directory m-has-icon m-3-columns">
                        <Switch>
                            {
                                contents
                            }
                            {
                                errorpage
                            }
                        </Switch>
                    </div>
                </div>
            </div>
        )
    }
}

export default Content


// WEBPACK FOOTER //
// ./src/components/content/main/Content.js